
export default {
    "API_URL": "https://kuveytv3.maxsoftlab.com/",
    "SOCKET_URL": "https://socket.maxsoftlab.com",
    "MAX_API": "https://maxapi.maxsoftlab.com/",
    "AUTH_STORAGE_KEY": "trader_auth",
    "REF": "KUVEYT_YATIRIM",
    "SOCKET_ENV": "KUVEYT",
    "DEFAULT_THEME": "dark"
}